<template>
  <div
    class="home-scenes-body"
    :style="{ background: 'url(' + backgroundImgUrl + ')  top no-repeat' }"
    style="margin: 0"
  >
    <images
      style="display: none"
      :id="backgroundImg ? backgroundImg : ''"
      v-model="backgroundImgUrl"
    />
    <div>
      <div class="home-scenes-head-body">
        <div class="home-scenes-head-info" style="height: 380px">
          <!-- <p>2021年第二季度场景需求</p>
          <strong>发布会</strong>
          <div>

            垫江将新型智慧城市这个最大的应用场景分类分细，创新“一种需求、一个场景、一家企业”，大力开展场景招商，首批已开放工业互联网、数字普惠金融、智慧医疗、智慧交通、智慧气象等40余个应用场景，相应引进有实力的大数据企业近40家、数字经济人才300余人，全县大数据产业蓬勃发展。截至目前，全市推广的“警快办”平台获全国应用创新一等奖；“垫小二”云平台已成为“渝商在线服务平台”的全市首个试点；科特派服务“三农”信息平台已辐射至邻水等川渝毗邻地区；“智慧水利”云平台已成为长垫梁龙溪河流域联合共建智慧河长的基础平台。数字化赋能多点开花，让垫江探索更具示范价值。
          </div>
          <span @click="historyList">往期场景 >></span> -->
        </div>
        <div>
          <v-video
            v-if="settings.SCENE_PROPAGANDA_TYPE === '1'"
            controls
            width="560px"
            height="320px"
            :attachment-id="
              scenePublicityVideo &&
              scenePublicityVideo.attachment &&
              scenePublicityVideo.attachment.attachmentId
            "
            src="@/assets/img/demand-dj.mp4"
          />
          <div
            v-else-if="settings.SCENE_PROPAGANDA_TYPE === '2'"
            class="home-scenes-carousel-body"
          >
            <a-carousel autoplay dots-class="home-scenes-carousel">
              <div
                class="home-news-carousel-list"
                v-for="item in scenePublicityImgs"
                :key="item.id"
              >
                <v-img
                  :attachment-id="
                    item.attachment && item.attachment.attachmentId
                  "
                  :default-img="require('@/assets/img/mediaPic1.jpg')"
                  @click="handleBannerClick(item)"
                ></v-img>
              </div>
            </a-carousel>
          </div>
        </div>
      </div>
      <div class="home-scenes-list-content-body">
        <p>场景需求清单</p>
        <span @click="historyList">往期场景 >></span>
        <div class="home-scenes-filter-body">
          <div>
            <span>状态：</span>
            <div>
              <span :class="{ active: stateCode == '' }" @click="stateCode = ''"
                >全部</span
              >
              <span
                v-for="(item, index) in stateData"
                :key="index"
                :class="{ active: stateCode == item.code }"
                @click="stateCode = item.code"
                >{{ item.text }}</span
              >
              <span
                :class="{ active: stateCode == 'EXPIRED' }"
                @click="stateCode = 'EXPIRED'"
                >已过期</span
              >
            </div>
          </div>
          <div>
            <span>场景领域：</span>
            <div :style="{ height: fieldShow ? 'auto' : '48px' }">
              <span :class="{ active: fieldCode == '' }" @click="fieldCode = ''"
                >全部</span
              >
              <span
                v-for="(item, index) in fieldData"
                :key="index"
                :class="{ active: fieldCode == item.code }"
                @click="fieldCode = item.code"
                >{{ item.text }}</span
              >
            </div>
            <p @click="fieldShow = !fieldShow">
              {{ fieldShow ? "收起" : "展开" }}
              <a-icon :type="fieldShow ? 'up' : 'down'" />
            </p>
          </div>
          <div>
            <span>应用行业：</span>
            <div
              class="list-show"
              :style="{ height: industryShow ? 'auto' : '48px' }"
            >
              <span
                :class="{ active: industryCode == '' }"
                @click="industryCode = ''"
                >全部</span
              >
              <span
                v-for="(item, index) in industryData"
                :key="index"
                :class="{ active: industryCode == item.code }"
                @click="industryCode = item.code"
                >{{ item.text }}</span
              >
            </div>
            <p @click="industryShow = !industryShow">
              {{ industryShow ? "收起" : "展开" }}
              <a-icon :type="industryShow ? 'up' : 'down'" />
            </p>
          </div>
          <div :style="{ height: skillShow ? 'auto' : '32px' }">
            <span>技术类别：</span>
            <div class="list-show">
              <span :class="{ active: skillCode == '' }" @click="skillCode = ''"
                >全部</span
              >
              <span
                v-for="(item, index) in skillData"
                :key="index"
                :class="{ active: skillCode == item.code }"
                @click="skillCode = item.code"
                >{{ item.text }}</span
              >
            </div>
            <p @click="skillShow = !skillShow">
              {{ skillShow ? "收起" : "展开" }}
              <a-icon :type="skillShow ? 'up' : 'down'" />
            </p>
          </div>
        </div>
        <div class="home-scenes-list-body">
          <div class="home-scenes-list-search">
            <div>
              <span>共 {{ page.total }} 项需求</span>
              <p :class="{ active: sortTabIndex == 0 }" @click="sortTab(0)">
                综合排序
              </p>
              <p :class="{ active: sortTabIndex == 1 }" @click="sortTab(1)">
                发布时间
                <span>
                  <a-icon
                    :class="{ active: sortTime == 'PublishTimeDesc' }"
                    type="caret-up"
                  />
                  <a-icon
                    :class="{ active: sortTime == 'PublishTimeAsc' }"
                    type="caret-down"
                  />
                </span>
              </p>
              <!-- <p :class="{ active: sortTabIndex == 2 }" @click="sortTab(2)">
                金额
                <span>
                  <a-icon
                    :class="{ active: sortPrice == 'PriceDesc' }"
                    type="caret-up"
                  />
                  <a-icon
                    :class="{ active: sortPrice == 'PriceAsc' }"
                    type="caret-down"
                  />
                </span>
              </p> -->
            </div>
            <a-input-search
              style="width: 360px"
              placeholder="请输入关键词搜索"
              enter-button
              v-model="scenesVal"
              @search="searchScenes"
            />
          </div>
          <div class="home-scenes-list-body">
            <template v-if="sceneListData != ''">
              <div
                class="home-scenes-list"
                v-for="item in sceneListData"
                :key="item.id"
                @click="scenesDetail(item.id)"
              >
                <div class="home-scenes-list-info">
                  <span>
                    <images
                      :id="
                        item.coverAttachment
                          ? item.coverAttachment.attachmentId
                          : ''
                      "
                    />
                  </span>
                  <div>
                    <strong
                      v-if="
                        scenesVal && item.sceneName.indexOf(scenesVal) !== -1
                      "
                    >
                      <span>{{
                        item.sceneName.substring(
                          0,
                          item.sceneName.indexOf(scenesVal)
                        )
                      }}</span>
                      <span style="color: red">{{ scenesVal }}</span>
                      <span>{{
                        item.sceneName.substring(
                          item.sceneName.indexOf(scenesVal) + scenesVal.length,
                          item.sceneName.length
                        )
                      }}</span>
                    </strong>
                    <strong v-else>{{ item.sceneName }}</strong>
                    <div>
                      <p>需求单位：{{ item.ownerName }}</p>
                      <p>发布时间：{{ item.publishTime }}</p>
                      <p>截止日期：{{ item.applyDueDate }}</p>
                    </div>
                    <p v-html="item.description"></p>
                  </div>
                </div>
                <div class="home-scenes-list-price">
                  <p><span>￥</span>{{ item.fundAmount }}<span>万</span></p>
                  <span>意向金额</span>
                </div>
              </div>
              <div class="home-dynamic-page">
                <a-pagination
                  @change="scenePage"
                  show-quick-jumper
                  :default-page-size="5"
                  :default-current="page.current"
                  :total="page.total"
                  :show-total="(total) => `共 ${total} 项`"
                />
              </div>
            </template>
            <div v-else style="padding: 50px 0">
              <a-empty>
                <img slot="image" src="@/assets/img/cjsh.png" />
              </a-empty>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  commonCode,
  getSceneAdBanner,
  getScenePublicity,
  sceneList,
} from "@/api/scene";
import images from "@/page/components/image";
import VImg from "@/components/VImg";
import { mapGetters } from "vuex";
import VVideo from "@/components/VVideo";

export default {
  components: {
    VVideo,
    images,
    VImg,
  },
  data() {
    return {
      fieldShow: false,
      industryShow: false,
      skillShow: false,
      stateCode: "",
      fieldCode: "",
      industryCode: "",
      scenesVal: "",
      stateData: [],
      fieldData: [],
      industryData: [],
      skillData: [],
      skillCode: "",
      page: {
        size: 5,
        current: 1,
        total: 0,
      },
      sortType: "Default",
      sceneListData: [],
      sortTabIndex: 0,
      sortTime: "",
      sortPrice: "",
      backgroundImg: "",
      backgroundImgUrl: "",
      scenePublicity: [],
    };
  },
  computed: {
    scenePublicityImgs() {
      const { scenePublicity } = this;
      return scenePublicity.filter(
        (e) => e.attachment && e.attachment.fileType !== "mp4"
      );
    },
    scenePublicityVideo() {
      const { scenePublicity } = this;
      return scenePublicity.filter(
        (e) => e.attachment && e.attachment.fileType === "mp4"
      )[0];
    },
    ...mapGetters(["settings"]),
  },
  mounted() {
    if (this.$route.query.code) {
      this.skillCode = this.$route.query.code;
    }
    this.loadState();
    this.loadfField();
    this.loadIndustry();
    this.loadSkill();
    this.loadSceneList();
    this.getBackImg();
    this.loadgetScenePublicity();
  },
  watch: {
    stateCode: function () {
      this.page.current = 1;
      this.loadSceneList();
    },
    fieldCode: function () {
      this.page.current = 1;
      this.loadSceneList();
    },
    industryCode: function () {
      this.page.current = 1;
      this.loadSceneList();
    },
    skillCode: function () {
      this.page.current = 1;
      this.loadSceneList();
    },
  },
  methods: {
    getBackImg() {
      getSceneAdBanner().then((res) => {
        this.backgroundImg = res.data.attachment.attachmentId;
      });
    },
    loadgetScenePublicity() {
      getScenePublicity().then((res) => {
        this.scenePublicity = res.data;
      });
    },
    loadState() {
      let obj = {
        type: "WORKFLOW",
        precode: "SYS02",
      };
      commonCode(obj).then((res) => {
        this.stateData = res.data;
      });
    },
    loadfField() {
      let obj = {
        type: "FIELD",
        precode: "000",
      };
      commonCode(obj).then((res) => {
        this.fieldData = res.data;
      });
    },
    loadIndustry() {
      let obj = {
        type: "INDUSTRY",
        precode: "000",
      };
      commonCode(obj).then((res) => {
        this.industryData = res.data;
      });
    },
    loadSkill() {
      let obj = {
        type: "SKILL",
        precode: "000",
      };
      commonCode(obj).then((res) => {
        this.skillData = res.data;
      });
    },
    // 列表
    loadSceneList() {
      let obj = {
        batch: "",
        status: this.stateCode,
        field: this.fieldCode,
        industry: this.industryCode,
        skill: this.skillCode,
        keywords: this.scenesVal,
        sort: this.sortType,
      };
      sceneList(this.page, obj).then((res) => {
        this.page.total = res.data.total;
        this.sceneListData = res.data.records;
      });
    },
    scenePage(e) {
      this.page.current = e;
      this.loadSceneList();
    },
    searchScenes() {
      this.page.current = 1;
      this.loadSceneList();
    },
    sortTab(index) {
      this.sortTabIndex = index;
      if (index == 1) {
        if (this.sortTime == "") {
          this.sortTime = "PublishTimeDesc";
        } else if (this.sortTime == "PublishTimeDesc") {
          this.sortTime = "PublishTimeAsc";
        } else {
          this.sortTime = "PublishTimeDesc";
        }
        this.sortType = this.sortTime;
      }
      if (index == 2) {
        if (this.sortPrice == "") {
          this.sortPrice = "PriceDesc";
        } else if (this.sortPrice == "PriceDesc") {
          this.sortPrice = "PriceAsc";
        } else {
          this.sortPrice = "PriceDesc";
        }
        this.sortType = this.sortPrice;
      }
      this.loadSceneList();
    },
    historyList() {
      this.$router.push("/homeScenes/historyList");
    },
    scenesDetail(id) {
      this.$router.push({
        path: "/homeScenes/detail",
        query: { id: id },
      });
    },
    handleBannerClick(el) {
      if (el.link) {
        window.open(`${el.link}`);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home-scenes-body {
  background: url(../../assets/img/scenesbg.png) top no-repeat;

  > div {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 80px;

    .home-scenes-head-body {
      display: flex;
      justify-content: space-between;
      padding-top: 64px;
      margin-bottom: 50px;

      .home-scenes-head-info {
        flex: 1;
        margin-right: 80px;

        > p {
          font-size: 34px;
          line-height: 34px;
          font-weight: bold;
          color: #ffffff;
          line-height: 30px;
          text-shadow: 0px 5px 0px #0009bb;
          margin-bottom: 32px;
        }

        > strong {
          display: block;
          font-size: 64px;
          color: #ffffff;
          line-height: 64px;
          text-shadow: -3px 1px 0px #1ed2ff, 7px 0px 0px #0009bb;
          margin-bottom: 40px;
        }

        > div {
          line-height: 22px;
          color: #fff;
          margin-bottom: 30px;
        }

        > span {
          width: 120px;
          height: 32px;
          border: 1px solid rgba(255, 255, 255, 0.4);
          line-height: 30px;
          text-align: center;
          color: #fff;
          display: block;
          cursor: pointer;
        }
      }
    }

    .home-scenes-list-content-body {
      width: 100%;
      background: #fff;
      position: relative;

      > span {
        position: absolute;
        width: 120px;
        height: 32px;
        border: 1px solid #8c8c8c;
        line-height: 30px;
        text-align: center;
        color: #262626;
        display: block;
        cursor: pointer;
        top: 20px;
        right: 24px;
      }

      > p {
        width: 246px;
        height: 56px;
        text-align: center;
        line-height: 56px;
        background: url(../../assets/img/scenestitlebg.png);
        color: #fff;
        font-size: 24px;
        margin: 0 auto;
        transform: translateY(-28px);
      }

      .home-scenes-filter-body {
        padding: 0 24px 24px 24px;
        border-bottom: 1px solid #f0f0f0;

        > div {
          display: flex;

          > span {
            width: 64px;
            height: 32px;
            line-height: 32px;
            white-space: nowrap;
            text-align: right;
            margin-right: 10px;
          }

          > p {
            width: 80px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            margin-left: 16px;
            cursor: pointer;
            background: #f5f5f5;
          }

          > div {
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            overflow: hidden;

            > span {
              height: 32px;
              line-height: 32px;
              padding: 0 18px;
              margin-bottom: 16px;
              cursor: pointer;

              &.active {
                background: #1abc9c;
                color: #fff;
              }
            }
          }
        }
      }

      .home-scenes-list-body {
        padding: 16px 24px;

        .home-scenes-list-search {
          display: flex;
          justify-content: space-between;
          align-items: center;

          > div {
            display: flex;
            align-items: center;

            > span {
              color: #8c8c8c;
              line-height: 14px;
              margin-right: 16px;
              padding-right: 16px;
              border-right: 1px solid #f0f0f0;
            }

            > p {
              color: #595959;
              line-height: 14px;
              display: flex;
              align-items: center;
              margin-right: 24px;
              cursor: pointer;

              &.active {
                color: #1abc9c;
              }

              > span {
                margin-left: 6px;

                > i {
                  display: block;
                  font-size: 8px;
                  color: #d9d9d9;

                  &.active {
                    color: #1abc9c;
                  }
                }
              }
            }
          }
        }

        .home-scenes-list-body {
          .home-scenes-list {
            border-bottom: 1px solid #f0f0f0;
            padding: 32px 0;
            display: flex;
            justify-content: space-between;
            cursor: pointer;

            .home-scenes-list-info {
              width: 100%;
              display: flex;

              > span {
                width: 210px;
                height: 120px;
                margin-right: 24px;

                > img {
                  width: 100%;
                  height: 100%;
                  display: block;
                }
              }

              > div {
                flex: 1;

                > strong {
                  font-size: 16px;
                  line-height: 16px;
                  font-weight: bold;
                  display: block;
                  margin-bottom: 16px;
                }

                > div {
                  display: flex;
                  margin-bottom: 20px;

                  > p {
                    color: #595959;
                    margin-right: 24px;
                    line-height: 14px;

                    &:last-child {
                      margin-right: 0;
                    }

                    > span {
                      color: #1abc9c;
                    }
                  }
                }

                > p {
                  color: #8c8c8c;
                  line-height: 20px;
                  max-height: 60px;
                  overflow: hidden;
                  text-align: justify;
                }
              }
            }

            .home-scenes-list-price {
              display: none;

              > p {
                display: flex;
                align-items: flex-end;
                color: #1abc9c;
                font-size: 24px;
                font-weight: bold;
                line-height: 24px;
                margin-bottom: 12px;

                > span {
                  font-size: 14px;
                  line-height: 14px;
                }
              }

              > span {
                font-size: 12px;
                line-height: 12px;
                color: #8c8c8c;
                text-align: right;
                display: block;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style>
.home-dynamic-page {
  text-align: right;
  margin-top: 24px;
}

.home-scenes-list-search .ant-btn {
  background: #f5f5f5 !important;
  border-color: #d9d9d9 !important;
  color: #8c8c8c !important;
}

.home-scenes-carousel-body {
  width: 560px;
  height: 320px;
}

.home-news-carousel-list {
  width: 560px;
  height: 320px;
}
.home-news-carousel-list > img {
  max-height: 320px;
  max-width: 100%;
}
</style>
